import { render } from "./UserForm.vue?vue&type=template&id=0d4c5fcd&scoped=true&ts=true"
import script from "./UserForm.ts?vue&type=script&lang=ts"
export * from "./UserForm.ts?vue&type=script&lang=ts"

import "./UserForm.scss?vue&type=style&index=0&id=0d4c5fcd&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d4c5fcd"]])

export default __exports__